import { Establishment } from "src/app/services/api";
import { RootState } from "..";

export const selectLanguage = (state: RootState): Establishment.EnabledLanguagesEnum => state.app.language;
